import './ManualAccordion.scss'
import { useMemo } from 'react'

import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'

import { CHEVRON_DOWN_RIVER_BLUE } from '../../../assets/images'
import { useInversionData } from '../../../hooks/useInversionData'
import { getEnableFAQItems } from '../../../utils/accordion-util'
import { getInversionTokenValues } from '../../../utils/inversion-util'
import { getImageSrc } from '../../../utils/local-util'
import { Accordion } from '../../shared/ReactBootstrap'

const ManualAccordion = ({
  accordionIcon = CHEVRON_DOWN_RIVER_BLUE,
  alwaysOpen = false,
  childComponents,
  cqItems,
  cqItemsOrder = [],
  defaultActiveKey = [],
  enableFAQs = false
}: any): JSX.Element => {
  const handleAccordionNavClick = (itemKey: string) => {
    const isActive = defaultActiveKey.indexOf(itemKey) > -1
    const expandedItems = defaultActiveKey

    if (isActive) {
      const index = defaultActiveKey.indexOf(itemKey)
      expandedItems.splice(index)
    } else {
      expandedItems.push(itemKey)
    }
  }

  const inversionItems = useInversionData()
  const newItems = useMemo(() => inversionItems, [inversionItems])
  const { appData } = useAppDataContext()
  const isLocal = appData?.page?.isLocal
  const invTokenregex = /\[\[(?!token|offer)[^\]]+\]\]/g

  const {
    enableFAQsNameElement,
    enableFAQsTextElement,
    enableFAQsPageElement,
    enableFAQsQuestionElement,
    enableFAQsAnswerElement
  } = getEnableFAQItems(enableFAQs)

  return (
    <Accordion
      className={`react-accordion`}
      alwaysOpen={alwaysOpen}
      defaultActiveKey={defaultActiveKey}
      flush
      {...enableFAQsPageElement}
    >
      {cqItemsOrder.map((key: any) => {
        const item = cqItems[key] as any
        const itemContentIndex = cqItemsOrder.indexOf(key)
        let title = item['cq:panelTitle'] as any
        if (isLocal) {
          if (invTokenregex.test(title)) {
            title = getInversionTokenValues(title, newItems)
          }
        }
        return (
          <Accordion.Item eventKey={`${key}`} key={`${key}-item`} {...enableFAQsQuestionElement}>
            <Accordion.Header
              as={'h3'}
              key={`${key}-header`}
              onClick={() => {
                handleAccordionNavClick(key)
              }}
            >
              <a role='button'>
                <div className='accordion-title' {...enableFAQsNameElement}>
                  {title}
                </div>
              </a>
              <div className='accordion-chevron' style={{ background: `url("${getImageSrc(accordionIcon)}")` }}></div>
            </Accordion.Header>
            <div className='accordion-item-container'>
              <Accordion.Body {...enableFAQsAnswerElement}>
                <div {...enableFAQsTextElement}>{childComponents[itemContentIndex]}</div>
              </Accordion.Body>
              <div className='divider'></div>
            </div>
          </Accordion.Item>
        )
      })}
    </Accordion>
  )
}

export default ManualAccordion
